import { readLocallyStored } from './local-storage';

export const getDeveloperFlag = (): boolean =>
    !!readLocallyStored('developer', false) || !!readLocallyStored('developerFeatureFlag', false);

export const DEBUG_KRISP_AUTO_MODE = !!readLocallyStored('debugKrispAutoMode', false);

export const DEBUG_KRISP_STATS = !!readLocallyStored('debugKrispStats', false);

export const DEBUG_WEBAUDIO_MEETING_AUDIO = !!readLocallyStored('debugMeetingAudio', false);

export const DEBUG_ISTIO_GATEWAY_INSECURE = !!readLocallyStored('debugIstioGatewayInsecure', false);

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0']);

export const isInsecureLocalDev = (): boolean =>
    DEBUG_ISTIO_GATEWAY_INSECURE &&
    typeof window !== 'undefined' &&
    LOCAL_HOSTS.has(window.location.hostname);

export const DEBUG_JUPITER_REDIRECT_MOCK_BASE_URI = readLocallyStored<string>('jupiterMockBaseUri');

export const DEBUG_MAX_BREAKOUT_ROOMS_PARTICIPANTS = readLocallyStored(
    'debugMaxBreakoutRoomsParticipants',
    false
);

export const DEBUG_FACE_TRACKING_ENGINE =
    typeof localStorage === 'undefined' ? null : localStorage.getItem('debugFaceTrackingEngine');
